import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import DefaultExpandLink from "./ExpandLink";

const Limiter = (props) => {
  const {
    renderContent,
    items,
    limit,
    ExpandLink,
    prioritiseEnd,
    shouldAutoCollapse,
  } = props;
  const [isExpanded, setExpanded] = useState(false);
  const limitedItems = prioritiseEnd
    ? items.slice(-limit)
    : items.slice(0, limit);
  const remaining = items.length - limit;
  const renderedItems = isExpanded ? items : limitedItems;
  const content = renderContent({ ...props, items: renderedItems });
  const toggle = () => setExpanded(!isExpanded);

  useEffect(() => {
    if (shouldAutoCollapse) {
      setExpanded(false);
    }
  }, [items]);

  return (
    <>
      {remaining > 0 && prioritiseEnd ? (
        <ExpandLink
          remaining={remaining}
          isExpanded={isExpanded}
          toggle={toggle}
        />
      ) : null}
      {content}
      {remaining > 0 && !prioritiseEnd ? (
        <ExpandLink
          remaining={remaining}
          isExpanded={isExpanded}
          toggle={toggle}
        />
      ) : null}
    </>
  );
};

Limiter.propTypes = {
  renderContent: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  limit: PropTypes.number.isRequired,
  prioritiseEnd: PropTypes.bool,
  shouldAutoCollapse: PropTypes.bool,
  ExpandLink: PropTypes.func,
};

Limiter.defaultProps = {
  ExpandLink: DefaultExpandLink,
  prioritiseEnd: false,
  shouldAutoCollapse: false,
};

export default Limiter;
